/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddTransferNoteRequestBody
 */
export interface AddTransferNoteRequestBody {
    /**
     * content of note
     * @type {string}
     * @memberof AddTransferNoteRequestBody
     */
    note: string;
}

/**
 * Check if a given object implements the AddTransferNoteRequestBody interface.
 */
export function instanceOfAddTransferNoteRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "note" in value;

    return isInstance;
}

export function AddTransferNoteRequestBodyFromJSON(json: any): AddTransferNoteRequestBody {
    return AddTransferNoteRequestBodyFromJSONTyped(json, false);
}

export function AddTransferNoteRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddTransferNoteRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function AddTransferNoteRequestBodyToJSON(value?: AddTransferNoteRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
    };
}

